import BrowsingItem from './BrowsingItem';

export default BrowsingItem;
